module.exports = __webpack_public_path__ + "img/cyan_rectangle.c7a6662e.png";